import PageModel from '@/models/pageModel';

export class Doctors extends PageModel {
    static moduleName = 'doctors';
    static moduleEntityName = 'doctorEntity';
    static listTitle = 'Врачи';
    static createTitle = 'Добавление нового врача';
    static editTitle = 'Изменение данных о враче';
    static apiPrefix = 'doctors';
}
